module.exports = __webpack_public_path__ + "images/fiat_smalld4244832302c6db94bdd523b1ca994f5.png";